import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { FlexBoxRow } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const breakPoints = {
    sDesktop: '1599px',
    laptop: '1365px',
    tablet: '1023px',
    mobile: '767px',
};

export const Wrapper = styled.div`
    width: 100%;
    overflow: hidden;
    background: ${COLORS.lightGrey};
`;

export const Grid = styled(GridContainer)`
    display: flex;
    flex-direction: column;
    margin-bottom: 116px;

    @media (max-width: ${breakPoints.laptop}) {
        margin-bottom: 112px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        margin-bottom: 64px;
    }
`;

export const CaruselRow = styled(FlexBoxRow)`
    width: 100%;
    z-index: 0;
`;

export const SectionRow = styled(FlexBoxRow)`
    flex-wrap: nowrap;

    @media (max-width: ${breakPoints.mobile}) {
        flex-direction: column;
    }
    z-index: 1;
`;

export const FormRow = styled(FlexBoxRow)`
    flex-direction: column;
    background: ${COLORS.white};
    border-radius: 16px;
    padding: 32px;
`;

export const Title = styled.p`
    ${FONTS.XXL};
    margin-bottom: 32px;

    @media (max-width: ${breakPoints.laptop}) {
        max-width: 240px;
        ${FONTS.L};
        margin-bottom: 20px;
    }
`;
